import { Controller } from "@hotwired/stimulus"

// Sizes an element to fill the space below its own top edge in its scroll container (the
// layout's scrolling content pane, or the window), so whatever sits above it (banners,
// notes, headings) never pushes it past the bottom and adds a scroll bar.
// data-fill-viewport-bottom-value: space to leave below it (px). A CSS min-height still
// applies, so on a very short window the page scrolls rather than squashing the element.
export default class extends Controller {
  static values = { bottom: { type: Number, default: 0 } }

  connect() {
    this.resize = this.resize.bind(this)
    window.addEventListener("resize", this.resize)
    this.resize()
  }

  disconnect() {
    window.removeEventListener("resize", this.resize)
  }

  resize() {
    const container = this.scrollContainer()
    const containerBottom = container ? container.getBoundingClientRect().bottom : window.innerHeight
    let height = Math.max(0, containerBottom - this.element.getBoundingClientRect().top - this.bottomValue)
    this.element.style.height = `${height}px`

    // Padding or content below the element can still overflow the container; take it back
    const overflow = container
      ? container.scrollHeight - container.clientHeight
      : document.documentElement.scrollHeight - window.innerHeight
    if (overflow > 0) {
      height = Math.max(0, height - overflow)
      this.element.style.height = `${height}px`
    }
  }

  // Nearest ancestor that scrolls vertically; null means the window scrolls
  scrollContainer() {
    for (let node = this.element.parentElement; node && node !== document.body; node = node.parentElement) {
      const overflowY = getComputedStyle(node).overflowY
      if (overflowY === "auto" || overflowY === "scroll") return node
    }
    return null
  }
}
